import { render, staticRenderFns } from "./WorkBlock.vue?vue&type=template&id=89abb534&"
import script from "./WorkBlock.vue?vue&type=script&lang=js&"
export * from "./WorkBlock.vue?vue&type=script&lang=js&"
import style0 from "./WorkBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports